import { defineMessages } from '@jutro/locale';

export default defineMessages({
    savingPolicyChange: {
        id: 'ml.endorsement.pup.directives.templates.pup-locations.savingPolicyChange',
        defaultMessage: 'Saving policy change'
    },
    locations: {
        id: 'ml.endorsement.pup.directives.templates.pup-locations.locations',
        defaultMessage: 'Locations'
    },
});
